export enum ChainKey {
  ARBITRUM = 'arbitrum',
  ARBITRUM_TESTNET = 'arbitrum-testnet',
  AVALANCHE = 'avalanche',
  AVALANCHE_TESTNET = 'avalance-testnet',
  BSC = 'bsc',
  BSC_TESTNET = 'bsc-testnet',
  CELO = 'celo',
  ETHEREUM = 'ethereum',
  FANTOM = 'fantom',
  FANTOM_TESTNET = 'fantom-testnet',
  FUSE = 'fuse',
  GÖRLI = 'goerli',
  HARMONY = 'harmony',
  HARMONY_TESTNET = 'harmony-testnet',
  HECO = 'heco',
  HECO_TESTNET = 'heco-testnet',
  MATIC = 'polygon',
  MATIC_TESTNET = 'matic-testnet',
  MOONBEAM_TESTNET = 'moonbeam-testnet',
  MOONRIVER = 'moonriver',
  OKEX = 'okex',
  OKEX_TESTNET = 'okex-testnet',
  PALM = 'palm',
  PALM_TESTNET = 'palm-testnet',
  RINKEBY = 'rinkeby',
  TELOS = 'telos',
  TELOS_TESTNET = 'telos-testnet',
  XDAI = 'xdai',
  MOONBEAM = 'moonbeam',
  MANTLE = 'mantle',
  MANTLE_TESTNET = 'mantle-testnet',
  BASE = 'base',
  BLAST = 'blast',
  CORE = 'core',
  CRONOS = 'cronos',
  LINEA = 'linea',
  PULSECHAIN = 'pulsechain',
  SCROLL = 'scroll',
  ZKSYNC = 'zksync',
}
